import {Button, Table} from "antd";
import React from "react";
import { Link } from "react-router-dom";

const InventoryAlertTable = ({ data, loading }) => {
  const columns = [
    {
      title: "Agency",
      dataIndex: "AgencyNumberAndName",
      key: "AgencyNumberAndName",
    },
    {
      title: "Plate Type",
      dataIndex: "PlateType",
      key: "PlateType",
    },
    {
      title: "Threshold",
      dataIndex: "Threshold",
      key: "Threshold",
    },
    {
      title: "On-hand",
      dataIndex: "OnHand",
      key: "OnHand",
    },
    {
      title: "Below by",
      dataIndex: "BelowBy",
      key: "BelowBy",
    },
    {
      title: "Actions",
      key: "actions",
      align: "center",
      render: (_, record) => {
        const url = `/salesVolumeAndThresholds?agencyKey=${record.AgencyKey}&showAtOrAboveThreshold=false&showWithNoThreshold=false`;

        return (
          <Link to={url}>
            <Button type="link" size="small">
              View Details
            </Button>
          </Link>
        );
      },
    },
  ];

  return (
    <Table
      rowKey={(record, idx) => idx}
      columns={columns}
      dataSource={data}
      loading={loading}
      pagination={false}
      size="small"
    />
  );
};

export default InventoryAlertTable;
